import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Role } from '../../../model/role';
import { Permission } from '../../../model/permission';
import { RolePermissions } from '../../../model/role-permissions';

import { StorageService } from '../../managers/storage.service';
import { Config } from '../config';

@Injectable({
  providedIn: 'root'
})
export class RolesService extends Config {


  constructor(private httpClient: HttpClient, private storageService: StorageService) {
    super();
  }

  public getRoles(maxItemPerPage, pageNumber, keyword): Observable<any> {

    let url;

    if (maxItemPerPage != null) {
      url = this.BASE_URL + 'role_get_all?maxItemPerPage=' + maxItemPerPage + "&page=" +
        pageNumber + "&keyword=" + keyword;
    }else{
      url = this.BASE_URL + 'role_get_all';
    }

    return this.httpClient.get(url, this.storageService.getHeaders());
  }

  public getRole(id: number) {
    let url = "role_get?id=" + id;

    return this.httpClient.get(this.BASE_URL + url, this.storageService.getHeaders());
  }

  public storeRole(role: Role) {
    let url = "role_store";

    return this.httpClient.post(this.BASE_URL + url, role, this.storageService.getHeaders());
  }

  public updateRole(role: Role) {
    let url = "role_update";

    return this.httpClient.post(this.BASE_URL + url, role, this.storageService.getHeaders());
  }

  public storeRolePermissions(rolePermissions: RolePermissions) {

    let url = "role_permissions_store";

    return this.httpClient.post(this.BASE_URL + url, rolePermissions, this.storageService.getHeaders());
  }

  public getRolePermissionsByRoleID(id: number) {
    let url: string;

    url = "role_get_permissions?id=" + id;

    return this.httpClient.get(this.BASE_URL + url, this.storageService.getHeaders());
  }

}
